import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FilterResponseModel } from '../models/filter/filter-response.model';
import { HttpService } from './../services/http.service';

@Injectable({
  providedIn: 'root'
})

export class GlobalService {
  @Output() renderRibbon: EventEmitter<number> = new EventEmitter();
  authCode: any;
  loggedInUser;
  subscription: string;
  environment: string;
  tagMovMsg;
  constructor(private readonly httpService: HttpService, public httpClient: HttpClient, public dialog: MatDialog) { }
  isAuthorize: boolean = false;
  isActivate: boolean = true;
  userDetails: any;
  firstTimeLoad: boolean = true;
  
  showAlert(model, data) {
    this.dialog.open(model, {
      width: '450px',
      panelClass: 'confirm-modalbox-dark',
      height: 'auto',
      data: data
    });
  }

  showAlertWithCallBack(model, data, methodRef: (thisRef: any, result?: any) => void, thisRef) {
    const dialogRef = this.dialog.open(model, {
      width: '450px',
      panelClass: 'confirm-modalbox-dark',
      height: 'auto',
      data: data
    });
    dialogRef.afterClosed().subscribe(result => {
      methodRef(thisRef);
    });
  }

  openModelWindow(methodRef: (thisRef: any, result?: any) => void, thisRef, modelComponent, widthOfWindow, panelClassName, dataToPass) {
    {
      const dialogRef = this.dialog.open(modelComponent, {
        width: widthOfWindow,
        panelClass: panelClassName,
        data: dataToPass
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result === true && methodRef != null) {
          methodRef(thisRef);
        }
        else if (result !== false && result !== undefined) {
          methodRef(thisRef, result);
        }
      });
    }
  }

  
  /**
   * Replaces display text for filter
   * @param tempText
   */
  replaceDisplayText(tempText: string) {
    if (tempText === 'tenantRefinery') {
      return 'Refinery';
    } else if (tempText === 'tenantName') {
      return 'Tenant';
    } else if (tempText === 'tenantSecurityGrp') {
      return 'Security Group';
    }else if (tempText === 'tenantId') {
      return 'Tenant Id';
    } else if (tempText === 'lastModifiedBy') {
      return 'Last Modified By';
    } else if (tempText === 'componentName') {
      return 'Component';
    } else if (tempText === 'datasourceName') {
      return 'Datasource';
    }  else if (tempText === 'datasourceTypeName') {
      return 'Type';
    } else if (tempText === 'datasourceTableName') {
      return 'Datasource Table';
    } else if (tempText === 'masterDataTable') {
      return 'Master Data Table';
    } else if (tempText === 'categoryName') {
      return 'Notification Category';
    } else if (tempText === 'subscribedBy') {
      return 'Subscribed By';
    } else if (tempText === 'subscribedDateTime') {
      return 'Subscribed Date and Time';
    } 
  }

  /**
   * Replace filter texts
   * @param tempText
   */
  replaceFilterText(tempText: string): string {
    if (tempText === 'Refinery') {
      return 'tenantRefinery';
    } else if (tempText === 'Tenant') {
      return 'tenantName';
    } else if (tempText === 'Version') {
      return 'version';
    } else if (tempText === 'Security Group') {
      return 'tenantSecurityGrp';
    } else if (tempText === 'Tenant Id') {
      return 'tenantId';
    } else if (tempText === 'Last Modified By') {
      return 'lastModifiedBy';
    } else if (tempText === 'Component') {
      return 'componentName';
    } else if (tempText === 'Datasource') {
      return 'datasourceName';
    }  else if (tempText === 'Type') {
      return 'datasourceTypeName';
    } else if (tempText === 'Datasource Table') {
      return  'datasourceTableName';
    } else if (tempText === 'Master Data Table') {
      return 'masterDataTable';
    } else if (tempText === 'Notification Category') {
      return 'categoryName';
    } else if (tempText === 'Subscribed By') {
      return 'subscribedBy';
    } else if (tempText === 'Subscribed Date and Time') {
      return 'subscribedDateTime';
    } else {
      return '';
    }
  }

  /**
   * 
   * @param filterResponse
   */
  conditionalDataFiltering(filterResponse: FilterResponseModel, data) {
    let temp;
    if (filterResponse.selectedFieldName !== 'version' && filterResponse.selectedFieldName !=="tenantId") {
      switch(filterResponse.selectedValue.length){
      case 1: {
        temp = data.filter(function (df) {
          return (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[0]);
        });
        break;
      } 
      case 2: {
        temp = data.filter(function (df) {
          return (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[0]) || (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[1]);
        });
        break;
      } 
      case 3: {
        temp = data.filter(function (df) {
          return (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[0]) || (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[1])
            || (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[2]);
        });
        break;
      } 
      case 4: {
        temp = data.filter(function (df) {
          return (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[0]) || (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[1])
            || (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[2]) || (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[3]);
        });
        break;
      } 
     case 5: {
        temp = data.filter(function (df) {
          return (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[0]) || (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[1])
            || (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[2]) || (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[3])
            || (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[4]);
        });
        break;
      }
      default:{break;}
    }
    } else {
      switch(filterResponse.selectedCondition){
      case '==': {
        temp = data.filter((df) => df[filterResponse.selectedFieldName] === filterResponse.selectedValue[0]);
        break;
      }
      case '>=': {
        temp = data.filter((df) => df[filterResponse.selectedFieldName] >= parseInt(filterResponse.selectedValue[0], 10));
        break;
      } 
      case '<=': {
        temp = data.filter((df) => df[filterResponse.selectedFieldName] <= parseInt(filterResponse.selectedValue[0], 10));
        break;
      }
      default:{break;}
    }
    }
    return temp;
  }

  /**
   * Checks if the given object is not undefined or null.
   * @param data string to be checked
   */
  isNotNullObject(data) {
    let response: boolean = false;
    if (data !== undefined && data != null) {
      response = true;
    }
    return response;
  }

  /**
   * Checks if the given string parameter is not undefined, null or empty.
   * @param data string to be checked
   */
  isNotNull(data: string) {
    let response: boolean = false;
    if (data !== undefined && data != null && data !== '') {
      response = true;
    }
    return response;
  }

  getAssetAppConfig() {
    let request = new XMLHttpRequest();
    request.open('GET', './assets/config/app-config.json', false);
    request.setRequestHeader('Cache-Control', 'max-age=0');
    request.send(null);

    if (request.status === 200) {
      let data = JSON.parse(request.responseText);
      return data;
    }
  }

  /**
   * Filters data based on input text
   * @param filterValue
   */
  applyFilter(filterValue: string, dataSource) {
    filterValue = filterValue.trim().toLowerCase(); // Remove whitespace and MatTableDataSource defaults to lowercase matches
    dataSource.filter = filterValue;
  }

}
